import { render, staticRenderFns } from "./SharesLabelBig.vue?vue&type=template&id=6a0248fe&scoped=true"
import script from "./SharesLabelBig.vue?vue&type=script&lang=js"
export * from "./SharesLabelBig.vue?vue&type=script&lang=js"
import style0 from "./SharesLabelBig.vue?vue&type=style&index=0&id=6a0248fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0248fe",
  null
  
)

export default component.exports